import { SettingsOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';
import { getMenuLabel } from '../../global/auth/use-menu-labels/use-menu-labels';

const route = 'admin';

export const getAdminRoutesMap = ({ userIdentityService, org }: GetRoutesConfig): RoutesMaps => {
  const menuLabels = org?.menuLabels;

  return {
    route,
    heading: 'Admin',
    Icon: SettingsOutlined,
    isAuthorized: userIdentityService.isVmAdmin,
    items: [
      {
        ...getMenuLabel('adminTaskManagement', menuLabels),
        id: 'admin.tasks',
        route: 'tasks',
        isAuthorized: true,
      },
      {
        ...getMenuLabel('adminFormsSurveys', menuLabels),
        id: 'admin.forms',
        route: 'forms',
        isAuthorized: true,
        hidden: org?.packageConfig ? !org.packageConfig.forms : false,
      },
      {
        ...getMenuLabel('adminProgramManagement', menuLabels),
        id: 'admin.program-management',
        route: 'program-management',
        isAuthorized: true,
      },
      {
        ...getMenuLabel('adminConsole', menuLabels),
        id: 'admin.admin-console',
        route: 'admin-console',
        isAuthorized: true,
      },
    ],
  };
};
